import store from '@/store'

export function getLanguageCode() {
  return store.state.language_code
}
